import React from 'react';
import MobileTitleNavbar from './mobile-title-navbar';

interface Props {
  children: React.ReactNode;
  overrideOnBack?: () => void;
}

const SimpleMobileSubpageNavbar = ({children, overrideOnBack}: Props): React.ReactElement => (
  <MobileTitleNavbar overrideOnBack={overrideOnBack}>{children}</MobileTitleNavbar>
);

export default SimpleMobileSubpageNavbar;
